module.exports = __webpack_public_path__ + "img/pic_ljyq@3x.d35e6798.png";